import CatalogItem from 'src/models/helperTypes/CatalogItem';

export const idTypes: CatalogItem[] = [
  { Text: 'Cédula', Value: 'N' },
  { Text: 'Pasaporte', Value: 'P' },
  { Text: 'DIMEX', Value: 'U' },
];

export default idTypes;
